<form [formGroup]="serviceAgreementForm">
  <label class="checkbox py-2">
    <input type="checkbox" name="agreed" formControlName="agreed" data-qa-id="Service Agreement Checkbox" /> I agree to
    the <a [href]="termsOfServiceUrl" target="_blank">Terms of Service</a>.
  </label>
  <div *ngIf="isFormControlInvalid('agreed')" class="error" data-qa-id="Service Agreement Error">
    Please agree to the Terms of Service before placing your order
  </div>
</form>
